// Termin-Ansicht in der Monteur-App (A-027 S3): für Termine ohne Einsatz – Zeit, Kunde, Adresse mit Navigation, Telefon, Auftrag.
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Mail, User as UserIcon } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ladeMonteurFarben } from "@/lib/avatarUtils";
import { TerminKarte, useTerminAktionen } from "./MeinPlan";

export function MonteurTerminPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [t, setT] = useState(null);
  const [fehler, setFehler] = useState("");
  const lade = useCallback(async () => {
    try {
      await ladeMonteurFarben();
      const r = await api.get(`/monteur/termine/${id}`);
      setT(r.data);
    } catch (err) {
      setFehler(err?.response?.data?.detail || "Termin konnte nicht geladen werden");
      if (err?.response) toast.error(err.response.data?.detail || "Fehler");
    }
  }, [id]);
  useEffect(() => { lade(); }, [lade]);
  const { go, erledigt } = useTerminAktionen(lade);

  return (
    <div className="max-w-3xl mx-auto" data-testid="monteur-termin-seite">
      <button onClick={() => navigate("/monteur")} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-3" data-testid="monteur-termin-zurueck">
        <ArrowLeft className="w-4 h-4" /> Zurück
      </button>
      {fehler && !t && <div className="text-center py-12 text-muted-foreground">{fehler}</div>}
      {t && (
        <div className="space-y-3">
          <TerminKarte t={t} onOeffnen={() => {}} onGo={() => go(t)} onErledigt={() => erledigt(t)} />
          {t.kunde && (
            <div className="bg-card border rounded-xl p-4 text-sm space-y-1" data-testid="monteur-termin-kunde">
              <div className="flex items-center gap-1 font-semibold"><UserIcon className="w-4 h-4" /> {t.kunde.name}</div>
              {t.kunde.email && <a href={`mailto:${t.kunde.email}`} className="flex items-center gap-1 text-primary"><Mail className="w-4 h-4" /> {t.kunde.email}</a>}
            </div>
          )}
          {t.beschreibung && (
            <div className="bg-card border rounded-xl p-4 text-sm whitespace-pre-wrap" data-testid="monteur-termin-beschreibung">{t.beschreibung}</div>
          )}
        </div>
      )}
    </div>
  );
}
